import { FC } from 'react';
import { Chip } from '@mui/material';
import { capitalize } from 'lodash';
import { ETLJobStatusEnum } from '~/api/types';
import { RunningETLJobIcon, SuccessETLJobIcon, TerminateIcon } from '~/icons';
import { useAppDispatch } from '~/redux';
import { ModalTypesEnum, openModal } from '~/redux/slices/modalSlice';
import { jobStatusCellStyles } from './styles';

interface JobStatusCellProps {
  status: ETLJobStatusEnum;
  details?: string;
}

const defaultChipConfig = {
  customColor: 'infoHighlight.main',
  customIcon: <RunningETLJobIcon />,
};

const etlJobStatusChipConfig: Partial<Record<ETLJobStatusEnum, { customColor: string; customIcon: JSX.Element }>> = {
  [ETLJobStatusEnum.RUNNING]: defaultChipConfig,
  [ETLJobStatusEnum.SUCCESS]: {
    customColor: 'success.light',
    customIcon: <SuccessETLJobIcon />,
  },
  [ETLJobStatusEnum.FAILED]: {
    customColor: 'criticalHighlight.main',
    customIcon: <TerminateIcon style={{ width: '16px' }} />,
  },
  [ETLJobStatusEnum.CANCELLED]: {
    customColor: 'criticalHighlight.main',
    customIcon: <TerminateIcon style={{ width: '16px' }} />,
  },
};

const JobStatusCell: FC<JobStatusCellProps> = ({ status, details }) => {
  const config = etlJobStatusChipConfig[status] ?? defaultChipConfig;
  const dispatch = useAppDispatch();

  return (
    <Chip
      label={capitalize(status)}
      icon={config.customIcon}
      onClick={() => {
        if (details) {
          dispatch(openModal({ type: ModalTypesEnum.FAILED_ETL_JOB_DETAILS, payload: { details } }));
        }
      }}
      sx={jobStatusCellStyles(Boolean(details), config?.customColor)}
    />
  );
};

export default JobStatusCell;
